export default __webpack_public_path__ + "static/media/game_final_jr.b7fba531.mp3";